export class WeeeItem {
    constructor() {
        this.id = "";
        this.name = "";
        this.img = "";
        this.price = 1;
        this.base_price = 1;
        this.unit_range = "";
        this.sub_name = "";
    }
}
export class WeeePage {
    constructor() {
        this.page = 1;
        this.pageSize = 1;
        this.totalCount = 1;
        this.totalPage = 1;
    }
}
export class WeeeData {
    constructor() {
        this.source = "";
        this.items = [];
        this.link = "";
    }
}
export class WeeeResponse {
    constructor() {
        this.done = false;
    }
}
